import Vue from 'vue'
import Dsp2022Cycle from './Dsp2022Cycle.vue'
import vuetify from './plugins/vuetify';
import router from './router'


if(process.env.NODE_ENV === 'production'){
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
} else {
  Vue.config.productionTip = false;
}

new Vue({
  vuetify,
  router,
  render: h => h(Dsp2022Cycle)
}).$mount('#app');

